<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="$resourceLoading()">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>

  <ng-container notifications />

  <ng-container actions>
    @let assignAction = $assignUserToBPAction();
    @let impersonateAction = $impersonateUserAction();
    @let endImpersonateAction = $endImpersonationAction();
    @if (!!assignAction) {
      <unity-action-shared [action]="assignAction" />
    }
    @if (!!impersonateAction) {
      <unity-action-shared [action]="impersonateAction" />
    }
    @if (!!endImpersonateAction) {
      <unity-action-shared [action]="endImpersonateAction" />
    }
    <unity-workflow-selector-shared
      [transitions]="$availableTransitions()"
      [disabled]="$workflowActionsDisabled()"
      (workflowEvent)="onWorkflow($event)" />
  </ng-container>

  @let formGroup = $formGroup();

  <unity-panel-manage-shared
    [resource]="$resource()"
    [resourceName]="resourceName"
    [formGroup]="formGroup"
    [isEditable]="$isEntitledToEdit()"
    [submitLoading]="$updateLoading()"
    [workflowCanChange]="$canEditStatus()"
    (saveEvent)="onSave()"
    (detailEditEvent)="toggleWorkflowActions($event)">
    <unity-form-layout>
      @if (mainResource.hasValue()) {
        <unity-textbox-readonly-control displayName="Email" [value]="mainResource.value().user_name" />
      }
      <unity-textbox-control displayName="Full Name" description="Enter the user's full name." [control]="formGroup.controls.full_name" />
    </unity-form-layout>
  </unity-panel-manage-shared>
  @let userId = $resource()?.id;
  @if (!!userId) {
    <unity-grid-agreement-shared *unityAuthorizeForInternal="'Agreement:View'" [userId]="userId" />
    <unity-grid-user-role-shared *unityAuthorizeForInternal="'UserRole:View'" [userId]="userId" />
  }
</unity-page-container>

@if ($impersonationError()) {
  <unity-dialog-confirm-shared title="Switch Impersonation?" (closeEvent)="closeErrorDialog()" (confirmEvent)="switchImpersonation()">
    <ng-content ngProjectAs="[dialog-body]">
      <p>You are already impersonating {{ $myUserFullname() }}!</p>
      <p>Do you want to impersonate {{ $resource()?.full_name }} instead?</p>
    </ng-content>
  </unity-dialog-confirm-shared>
}
